import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { ConfigProvider } from 'antd';
import pl_PL from 'antd/lib/locale/pl_PL';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

import AppRouter from './app/AppRouter/index';
import store from './store/configureStore';
import { SeoHelmet } from './components';
import * as serviceWorker from './serviceWorker';

import 'react-notifications-component/dist/theme.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'semantic-ui-css/semantic.min.css';
import 'src/styles/reset.scss';
import 'src/styles/global.scss';
import 'src/styles/index.scss';

const SentryDNS =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? 'https://5fbe2a9ceab9a5aa5aaf19afcf4f58ce@sentry.beeweb.pl/2'
    : 'https://2372085b184d5df441c85bd6e6fde8e8@sentry.beeweb.pl/4';

if (import.meta.env.VITE_NODE_ENV !== 'development') {
  Sentry.init({
    dsn: SentryDNS,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],
    tracePropagationTargets: [
      'https://app.dentametr.pl/',
      'https://api-prod.dentametr.pl/api/',
      'https://api-staging.dentametr.pl/api/',
      'https://staging.dentametr-frontend.pages.dev/'
    ]
  });
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);
dayjs.updateLocale('pl', {
  weekStart: 1
});
dayjs.tz.setDefault('Europe/Warsaw');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ConfigProvider
        locale={pl_PL}
        theme={{
          token: { colorPrimary: '#13655b' },
          components: {
            Tabs: {
              titleFontSize: 16
            }
          }
        }}
      >
        <SeoHelmet />
        <Provider store={store}>
          <AppRouter />
        </Provider>
      </ConfigProvider>
    </HelmetProvider>
  </React.StrictMode>
);

serviceWorker.unregister();
